import { JobListState, READ_JOB_LIST_DATA_REQUEST, READ_JOB_LIST_DATA_SUCCESS, READ_JOB_LIST_DATA_FAILURE, JobListActionTypes } from "store/reducers/types/jobList/jobList";

const defaultState: JobListState = {
  isLoading: false,
  errorMessage: ""
};

export default function jobs(state = defaultState, action: JobListActionTypes): JobListState {
  switch (action.type) {
    case READ_JOB_LIST_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_JOB_LIST_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_JOB_LIST_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};